import { gql } from '@apollo/client';

export const explorerMentionRemove = gql`
  mutation explorerMentionRemove($req: MentionRemoveInput!) {
    explorerMentionRemove(req: $req)
  }
`;
